import { useEffect } from 'react';
import { toast } from 'sonner';

const SEQUENCE = [
  'ArrowUp', 'ArrowUp',
  'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight',
  'ArrowLeft', 'ArrowRight',
  'b', 'a',
];

const COLOURS = ['#007A78', '#D97706', '#1A2E2E', '#FBF9F4', '#005F5D'];

function burstConfetti() {
  const container = document.createElement('div');
  container.setAttribute('aria-hidden', 'true');
  container.style.cssText =
    'position:fixed;inset:0;pointer-events:none;z-index:2147483647;overflow:hidden;';
  document.body.appendChild(container);

  const count = 120;
  for (let i = 0; i < count; i++) {
    const piece = document.createElement('span');
    const size = 6 + Math.random() * 8;
    const left = 50 + (Math.random() - 0.5) * 20;
    const angle = (Math.random() - 0.5) * 220;
    const distance = 300 + Math.random() * 400;
    const fall = 400 + Math.random() * 400;
    const rotate = (Math.random() - 0.5) * 1440;
    const duration = 1400 + Math.random() * 1200;
    const colour = COLOURS[i % COLOURS.length];

    piece.style.cssText = `
      position:absolute;
      top:55%;
      left:${left}%;
      width:${size}px;
      height:${size * 0.4}px;
      background:${colour};
      border-radius:1px;
      opacity:0.95;
      transform:translate(-50%,-50%);
      will-change:transform,opacity;
    `;
    piece.animate(
      [
        { transform: 'translate(-50%,-50%) rotate(0deg)', opacity: 1 },
        {
          transform: `translate(calc(-50% + ${angle}px), calc(-50% + ${-distance}px)) rotate(${rotate / 2}deg)`,
          opacity: 1,
          offset: 0.4,
        },
        {
          transform: `translate(calc(-50% + ${angle * 1.2}px), calc(-50% + ${fall}px)) rotate(${rotate}deg)`,
          opacity: 0,
        },
      ],
      { duration, easing: 'cubic-bezier(0.15, 0.7, 0.3, 1)', fill: 'forwards' },
    );
    container.appendChild(piece);
  }

  window.setTimeout(() => container.remove(), 3200);
}

export function KonamiEasterEgg() {
  useEffect(() => {
    let buffer: string[] = [];
    let cooldown = false;

    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
        return;
      }
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      buffer = [...buffer, key].slice(-SEQUENCE.length);
      if (cooldown) return;
      if (buffer.length === SEQUENCE.length && buffer.every((k, i) => k === SEQUENCE[i])) {
        cooldown = true;
        burstConfetti();
        toast.success("🎩 You've unlocked Chartered mode.", {
          description: 'Compliance approves. Carry on, adviser.',
        });
        window.setTimeout(() => {
          cooldown = false;
          buffer = [];
        }, 3500);
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return null;
}

export default KonamiEasterEgg;
